import styled from 'styled-components';
import { breakpoints } from '@bnnvara/breakpoints';
export const CardBody = styled.div`
  height: 85px;
  padding: 8px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${breakpoints.md} {
    height: auto;
    padding: 12px 24px 12px 12px;
  }
`;
export const CardMeta = styled.div`
  font-family: ${({
  theme
}) => theme.fonts.primary};
  font-size: 12px;
  font-weight: 500;
  color: ${({
  theme
}) => theme.secondary.light};
`;
export const CardWrapper = styled.div`
  position: relative;
  width: 100%;
  background-color: ${({
  theme
}) => theme.base.white};
  display: flex;
  flex-direction: column;

  h2 {
    font-family: ${({
  theme
}) => theme.fonts.primary};
    font-size: 16px;
    line-height: 19px;
    font-weight: 500;
    word-break: break-word;
    color: ${({
  theme
}) => theme.base.black};
    margin-bottom: 0;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;

    &:after {
      content: '';
      display: block;
      position: relative;
      top: 5px;
      width: 100%;
      height: 4px;
      background-color: ${({
  theme
}) => theme.primary.main};
      transform: scaleX(0);
      transition: all 0.2s ease-in-out;
      transform-origin: left center;
    }
  }

  &:hover {
    h2 {
      &:after {
        content: '';
        transform: scaleX(1);
        transform-origin: left center;
        transition: all 0.2s ease-in-out;
      }
    }
  }

  ${breakpoints.md} {
    flex-direction: row;

    h2 {
      font-size: 18px;
      line-height: 20px;
    }
  }

  ${breakpoints.lg} {
    h2 {
      font-size: 20px;
      line-height: 24px;
    }
  }
`;
export const CardImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  flex-shring: 0;

  ${breakpoints.md} {
    width: 50%;
    padding-bottom: 28%;
    flex-shrink: 0;
  }
`;
export const CardImage = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;

  ${breakpoints.md} {
    position: absolute;
  }
`;
export const CardIconBox = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: auto;
  height: 32px;
  width: 32px;
  background-color: ${({
  theme
}) => theme.primary.main};
  display: flex;
  align-items: center;
  justify-content: center;
`;